import { capitalize } from 'lodash';
import { GoalCategory } from 'src/modules/goals/models/goals';

export const getGoalNameForLanguage = (goal: GoalCategory, language: string) => {
    const parsedLanguage = language.split('-').map(capitalize).join('');

    const field = `name${parsedLanguage}`;

    return goal[field] ? goal[field] : goal.name;
};
